import React from 'react';
import { motion } from 'framer-motion';

const Section = ({ id, children, className = '', containerClass = 'max-w-7xl mx-auto px-6 md:px-12 lg:px-24' }) => {
  return (
    <section id={id} className={`py-24 md:py-32 ${className}`}>
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.6, ease: "easeOut" }}
        className={containerClass}
      >
        {children}
      </motion.div>
    </section>
  );
};

export default Section;